import { mapDTO } from '@twistezo/ts-dto-mapper'
import _ from 'lodash'

import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { variantsToDTO } from '../../useCreateAbTest'
import { FormData } from '../types'
import { Variables } from './types'

type From = FormData & {
  withYp2395: boolean
}

type To = Variables

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schema: From): To => {
    const { cookieLifetime, id, name, status, trafficSplitType, variants, withYp2395 } = schema

    const constantFields: Pick<Variables, 'id' | 'name' | 'status' | 'variants'> = {
      id,
      name,
      status,
      variants: variantsToDTO(variants),
    }

    const variableFields: Pick<Variables, 'cookieLifetime' | 'trafficSplitType'> = {
      cookieLifetime,
      trafficSplitType,
    }

    return {
      ...constantFields,

      ..._.omit(
        variableFields,
        fieldsToOmit<Variables>({
          cookieLifetime: !withYp2395,
          trafficSplitType: !withYp2395,
        }),
      ),
    }
  })
